import React from 'react';
import PropTypes from 'prop-types';

import Icon    from 'app/components/common/icon';
import Popper  from 'app/components/common/popper';

class EllipsisMenu extends React.PureComponent {

  render() {
    const {children, disabled, usePortal, left, target, className, icon} = this.props;
    const disabledClass = disabled ? 'disabled' : '';

    const popContent = (
      <div className="ellipsis-menu-dropdown">
        {children}
      </div>
    );

    return (
      <Popper
        tagType="div"
        tabIndex="-1"
        className={`ellipsis-menu ${className} ${disabledClass}`}
        popType="menu"
        popContent={popContent}
        focusTrigger
        placement={left ? 'bottom-start' : 'bottom-end'}
        disabled={disabled}
        usePortal={usePortal}
      >
        {target || (
          <div className="ellipsis-menu-toggle">{icon}</div>
        )}
      </Popper>
    );
  }

}

EllipsisMenu.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  usePortal: PropTypes.bool,
  left: PropTypes.bool,
  target: PropTypes.node,
  icon: PropTypes.node,
};

EllipsisMenu.defaultProps = {
  className: '',
  disabled: false,
  usePortal: false,
  left: false,
  target: null,
  icon: <Icon.EllipsisHorizontal />,
};

export default EllipsisMenu;
